import Vue from 'vue'
import App from './App.vue'
import router from './router'

import StateManager from './js/StateManager'

import vuetify from './plugins/Vuetify'
import 'vuetify/dist/vuetify.min.css'

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'
import './scss/main.scss'

Vue.config.productionTip = false;

const store = StateManager.store;

new Vue({
  el: '#app',
  router,
  vuetify,
  components: { App },
  template: '<App/>',
  store: store
})



// WEBPACK FOOTER //
// ./src/main.js